import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import {
    Modal,
    ModalBody
} from "reactstrap";


import classnames from 'classnames';
import { Link } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";

import arrrgt from '../../assets/images/arrow-right.svg';
import diamond from '../../assets/images/diamond.png';
import boomb from '../../assets/images/boomb.svg';

import { useTranslation, I18nextProvider, composeInitialProps } from "react-i18next";
import { getgamehistory, getoneGamehist, oneGamehist, winnerList } from "../../Features/MineBetFunction/betSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { NumericFormat } from 'react-number-format';

import { useCustomizeContext } from "../../context";
import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import { getGames, getAllMines, getSingleMine, getActiveGames } from "../../Features/GameCommon/gameCommonSlice";
import CreateBoard from "../../utils/CreateBoard";
import { revealed } from "../../utils/Reveal";
import Cell from "../../components/Cell";

import { bet, betMines, getCurrenctBet, updateBet, updateBetAuto, getMineHighRollers } from "../../Features/MineBetFunction/betSlice";
import { Notify } from "notiflix";

import { Radio } from "react-loader-spinner";

import useRefState from 'react-usestateref';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { SkeletonTheme } from 'react-loading-skeleton';
import useStateRef from "react-usestateref";
import { getSingleBetView } from "../../Features/GameCommon/gameCommonSlice";

import circle from '../../assets/images/close-circle.png';


let reveal;
let reveal1;
let reveal2;



let newBoardCreation;

const Mines = (props) => {
    const { t, i18n } = useTranslation();
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const [activeTab1, setActiveTab1] = useState('1');
    const toggleInner = tab => {
        if (activeTab1 !== tab) setActiveTab1(tab);
    }
    const [wifiLoad, setwifiLoad] = useState(false);
    const [selectedPoints, setSelectedPoints] = useState([]);



    const [onWinIsChecked, setOnWinIsChecked] = useState(false);
    const [onLossIsChecked, setOnLossIsChecked] = useState(false);

    const [maxBetAmount, setMaxBetAmount] = useState("");

    const [onWinAmount, setOnWinAmount] = useState("");
    const [onLossAmount, setOnLossAmount] = useState("");

    const [betCountIsActive, setBetCountIsActive] = useState(false);

    const [autoIsStop, setAutoIsStop] = useState(false);

    const [updateStatus, setUpdateStatus, statusRef] = useStateRef(false);

    const [slider, setSlider] = useState("");

    const [mineHighRollers, setMineHighRollers] = useState([]);

    const [betDetails, setBetDetails] = useState([]);



    //  Single Bet Details

    const toggleBetDetails = () => {
        setBetModal(!betModal);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        document.body.classList.remove("SideMenuOpen");
        setClassIsActive(false);
    }, []);

    const {
        loader: {
            loading, setLoading,
        },
        userAuthToken: {
            userToken,
        },
        bet: {
            isBet, setIsBet,
            selectedCurrency,
            betId, setBetId, betIdRef,
            mineId, setMineId, mineIdRef,
            balance, setBalance, balanceRef,
            selectCurrency, setSelectCurrency,
        },
        apiResponses: {
            updateRes, setUpdateRes,
        },
        modelStatus: {
            modal, setModal,
        },
        mineGameMode: {
            mineMode, setMineMode,
        },
        hitLength: {
            hitCount, setHitCount
        },
        betHistoryModal: {
            betModal, setBetModal,
        },
        sideMenu: {
            classIsActive, setClassIsActive
        },

    } = useCustomizeContext();

    let dispatch = useDispatch();
    // demo
    const [gameDetails, setGameDetails] = useState([]);
    const [mineRes, setMineRes] = useState([]);
    const [multiplier, setMultiplier] = useState([]);

    const [maxBet, setMaxBet] = useState("");
    const [minBet, setMinBet] = useState("");
    const [betAmount, setBetAmount, betRef] = useRefState("");

    // botRef.current = '432'

    const [mineCount, setMineCount] = useState("");
    const [diamondCount, setDiamond] = useState("");

    // Reveal Function


    // Board Creation 

    const [row, setRow] = useState(5);
    const [column, setColumn] = useState(5);

    const [grid, setGrid, gridRef] = useRefState([]);

    const [nonMinecount, setNonMinecount] = useState('');
    const [mineLocation, setmineLocation] = useState([]);

    // const [hitCount, setHitCount] = useState(0);

    const [cashValue, setCashValue] = useState("");

    const [points, setPoints] = useState([]);

    const [isVolume, setIsVolume] = useState(false);

    const [no_of_Bets, set_No_of_Bets] = useState("");

    const [stopOnProfit, setStopOnProfit] = useState("");

    const [lossAmount, setLossAmount] = useState("");
    const [stopOnLoss, setStopOnLoss] = useState("");

    const [isWon, setIswon, isWonRef] = useStateRef([]);

    const [multiplierValue, setMultiplierValue] = useState("");

    const [amtTemp, setTempAmt] = useState("");

    const [winPercentage, setWinPercentage] = useState("");
    const [lossPercentage, setLossPercentage] = useState("");

    const [onegamehistory, setOnegamehistory] = useState([]);


    // let values = [];

    const [values, setValues, valuesRef] = useRefState([]);  // useState([]);

    const [gamehist, setgamehist] = useState([]);
    const [winnerLists, setWinnerLists] = useState([]);



    const betCounts = [
        {
            pageLimit: "10",
            value: 10
        },
        {
            pageLimit: "20",
            value: 20
        },
        {
            pageLimit: "30",
            value: 30
        },
        {
            pageLimit: "40",
            value: 40
        },
        {
            pageLimit: "50",
            value: 50
        }
    ]

    useEffect(() => {
        gameBetHistory(betCounts[0]?.value)
    }, [userToken, updateRes]);

    const gameBetHistory = (limit) => {
        if (userToken) {
            oneGamehist(limit);
            gamehistory(limit);
            getMineGameHighRollers(limit);
        }
        else {
            gamehistory(limit);
            rareWinners(limit);
            getMineGameHighRollers(limit);
        }
    }

    const rareWinners = async (limit) => {
        if (mineMode === "manual") {
            // setLoading(true);
        }
        let res = await dispatch(winnerList({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setWinnerLists(res?.data)
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    const getMineGameHighRollers = async (limit) => {
        if (mineMode === "manual") {
            // setLoading(true);
        }
        let res = await dispatch(getMineHighRollers({
            "page": 1,
            "length": limit
        }));
        if (res?.status === true) {
            setMineHighRollers(res?.data);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    const oneGamehist = async (limit) => {
        if (mineMode === "manual") {
            // setLoading(true);
        }
        let res = await dispatch(getoneGamehist({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setOnegamehistory(res?.data)
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }

    const gamehistory = async (limit) => {
        if (mineMode === "manual") {
            // setLoading(true);
        }
        let res = await dispatch(getgamehistory({
            "page": 1,
            "length": limit
        }));
        if (res?.status) {
            setgamehist(res?.data);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }


    useEffect(() => {
        setBetId(localStorage.getItem("betId"));
        setMineId(localStorage.getItem("mineId"));
    }, []);

    useEffect(() => {
        getGame();
        getMines();
    }, []);

    useEffect(() => {
        if (betIdRef.current && mineIdRef.current && selectedCurrency) {
            currentBet();
            getMultiplier(mineIdRef?.current);
        }
    }, [betId, mineId, selectedCurrency]);

    const currentBet = async () => {
        let data = {
            _id: betIdRef.current
        }
        // setLoading(true);
        let res = await dispatch(getCurrenctBet(data));
        if (res?.status) {
            setBetAmount(res?.data?.betAmonut);
            setMineCount(res?.data?.mineCount);
            setNonMinecount(res?.data?.diamondCount);
            selectedCurrency?.map((temp, index) => {
                if (temp?.symbol === res?.data?.currency_name) {
                    setSelectCurrency(temp);
                    setBalance(temp?.originalBal?.toFixed(2));
                }
            })
            setIsBet(true);
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    }

    const getGame = async () => {
        let data = {
            "routes": "mines"
        }
        setLoading(true);
        let res = await dispatch(getGames(data));
        setTimeout(() => {
            if (res?.status) {
                setGameDetails(res?.data)
                setMaxBet(res?.data?.max_bet);
                setMinBet(res?.data?.min_bet);
                setBetAmount(5)
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 500);
    }

    var settings = {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3
                }
            },

            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4
                }
            },

            {
                breakpoint: 401,
                settings: {
                    slidesToShow: 3
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings:"unslick"
            // instead of a settings object
        ]
    };


    //  ===  Select Mode 

    const changeMode = (mode) => {
        if (mode === "manual") {
            toggle('1');
            setMineMode(mode);
            freshBoard();
            setSelectedPoints([]);
            setHitCount(0);
            setOnWinAmount("");
            setOnLossAmount("");

            setOnLossIsChecked(false);
            setOnWinIsChecked(false);
            set_No_of_Bets("");
            setStopOnProfit("");
            setStopOnLoss("");
            setMaxBetAmount("");
        }
        else if (mode === "auto") {
            toggle('2');
            setMineMode(mode);
            freshBoard();
            setAutoIsStop(true);
            setSelectedPoints([]);
            setHitCount(0);
            setOnWinAmount("");
            setOnLossAmount("");

            setOnLossIsChecked(false);
            setOnWinIsChecked(false);
            set_No_of_Bets("");
            setStopOnProfit("");
            setStopOnLoss("");
            setMaxBetAmount("");
        }
    }



    //  ==== >>> === >>> >>> Board Creation 

    const freshBoard = () => {
        setSelectedPoints([]);
        const newBoard = CreateBoard(row, column, mineCount);
        setNonMinecount(row * column - mineCount);
        setmineLocation(newBoard?.mineLocation);
        setGrid(newBoard?.board);
    }


    const fresh = async () => {
        return new Promise(async (resolve, reject) => {
            const newBoard = await CreateBoard(row, column, mineCount);
            selectedPoints.map((temp, index) => {
                let point = temp.toString();
                let x = point?.charAt(0);
                let y = point?.charAt(1);
                newBoardCreation = newBoard?.board;
                newBoardCreation[x][y].flagged = true;
            });
            setGrid(newBoardCreation);
            setmineLocation(newBoard?.mineLocation);
            setNonMinecount(row * column - mineCount);
            resolve({
                grid: newBoardCreation,
                mineLocation: newBoard?.mineLocation,
                nonMineCount: row * column - mineCount,
            });
        })
    }


    const updateFlag = (e, x, y) => {
        e.preventDefault();
        let newGrid = JSON.parse(JSON.stringify(grid));

        let a = newGrid[x][y].x.toString();
        let b = newGrid[x][y].y.toString();
        let point = a + b;

        if (selectedPoints?.length < diamondCount) {
            if (!selectedPoints.includes(point)) {
                setHitCount((prev) => prev + 1);
                selectedPoints.push(point);
                newGrid[x][y].flagged = true;
                if (selectedPoints?.length >= 2) {
                    setTimeout(() => {
                        slider?.slickNext();
                    }, 500);
                }
            }
            else if (selectedPoints.includes(point)) {
                setTimeout(() => {
                    slider?.slickPrev();
                }, 500);
                setHitCount((prev) => prev - 1);
                let index = selectedPoints.indexOf(point);
                selectedPoints.splice(index, 1);
                newGrid[x][y].flagged = false;
            }
            setGrid(newGrid);
        }
        else {
            if (selectedPoints.includes(point)) {
                setTimeout(() => {
                    slider?.slickPrev();
                }, 500);
                setHitCount((prev) => prev - 1);
                let index = selectedPoints.indexOf(point);
                selectedPoints.splice(index, 1);
                newGrid[x][y].flagged = false;
            }
            setGrid(newGrid);
        }
    }


    // =====  ====== ===== >>> >> >>  Manual Mode Function & UseEffect dependency ======

    //  >>> Get Mines Funtion

    const getMines = async () => {
        setLoading(true);
        let res = await dispatch(getAllMines());
        setTimeout(() => {
            if (res?.status) {
                setMineRes(res?.data);
                getMultiplier(mineIdRef.current ? mineIdRef.current : res?.data[3]._id);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 100);
    }

    //  >>> Get Multiplier Function

    const getMultiplier = async (id) => {
        if (id) {
            setBetCountIsActive(id);
            setMultiplier([]);
            let data = {
                "mineId": id
            }
            // setLoading(true);
            let res = await dispatch(getSingleMine(data));
            setTimeout(() => {
                if (res?.status) {
                    setMultiplier(res?.data?.hit_count);
                    setMineCount(res?.data?.mines);
                    setDiamond(res?.data?.diamonds);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
            }, 500);
        }
    }



    // >>> Bet Function

    const betFunction = async () => {
        if (+balanceRef.current <= +betAmount || +balanceRef.current == 0) {
            Notify.failure(balanceRef.current == 0 ? `${t('Not Enough Balance')} !!!` : "Bet Amount Must be less then Balance !! ", { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (+minBet > +betAmount) {
            Notify.failure(`${t('Bet Amount Must be higher then Minimum Amount')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (+maxBet < +betAmount) {
            Notify.failure(`${t('Bet Amount Must be higher then Minimum Amount')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else {
            let data = {
                "mine_level": mineCount,
                "bet_amonut": betAmount,
                "currency": selectCurrency?.symbol,
                "type": mineMode
            }
            setLoading(true);
            let res = await dispatch(betMines(data));
            console.log("🚀 ~ file: index.js:623 ~ betFunction MAnual ~ res:", res)
            setTimeout(() => {
                if (res?.status === true) {
                    setLoading(false);
                    localStorage.setItem("betId", res?.betId);
                    localStorage.setItem("mineId", res?.mineId);
                    setBetId(res?.betId);
                    setMineId(res?.mineId);
                    setIsBet(true);
                    freshBoard();
                    setUpdateRes(res);
                }
                else {
                    setLoading(false);
                }
            }, 500);
        }
    }

    //  >>> >>> >> Reveal Functionality 

    const revealcell = async (x, y) => {
        // slickNext();
        let point = x?.toString() + y?.toString();
        if (!selectedPoints.includes(point)) {
            setHitCount((prev) => prev + 1);
            let newGrid = gridRef?.current;
            if (newGrid[x][y].value === "X" && nonMinecount !== 0) {
                cashOutFun(true, "isMine")
                for (let i = 0; i < mineLocation?.length; i++) {
                    newGrid[mineLocation[i][0]][mineLocation[i][1]].revealed = true;
                }
                setGrid(newGrid);
            }
            if (nonMinecount === 0) {
                cashOutFun(true, "isDiamond");
            }
            else {
                let revealedboard = await revealed(newGrid, x, y, nonMinecount);
                setNonMinecount(revealedboard?.newNonMines);
                setGrid(revealedboard?.arr);

                multiplier?.map((temp, index) => {
                    if (index === hitCount) {
                        setCashValue((+temp?.multiplier * +betAmount).toFixed(2));
                    }
                })
            }
            selectedPoints.push(point);
        }
    }


    //  >>>  Mine Won & Loss Claim Function


    const cashOutFun = async (status, isWin) => {
        let data;
        let count = hitCount - 1;
        if (isWin === "isDiamond") {
            data = {
                "betid": betIdRef.current,
                "hitId": count === -1 ? 0 : hitCount,
                "isDiamond": status,
                "diamondCount": hitCount,
                // "amount": +cashValue,
                // "currency": selectCurrency?.symbol,
            }
        }
        else {
            data = {
                "betid": betIdRef.current,
                "hitId": count === -1 ? 0 : hitCount,
                "isMine": status,
                "diamondCount": 0,
                // "amount": +betAmount,
                // "currency": selectCurrency?.symbol,
            }
        }

        // setSelectCurrency(res?.data[0]);
        // setBalance(res?.data[0]?.amount);

        setLoading(true);
        let res = await dispatch(updateBet(data));
        console.log("🚀 ~ file: index.js:707 ~ Update Mine Game    ~ res:", res);
        setTimeout(() => {
            if (res?.status === true && res?.isWon === true) {
                setBalance(res?.balance?.toFixed(2));
                setMineId("");
                setBetId("");
                setCashValue("");
                setHitCount(0);
                setIsBet(false);
                setPoints([]);
                setUpdateRes(res)
                localStorage.removeItem("betId");
                localStorage.removeItem("mineId");
                setLoading(false);
                setTimeout(() => {
                    freshBoard();
                }, 3000);
            }
            else if (res?.status === false && res?.isWon === false) {
                setBalance(res?.balance?.toFixed(2));
                setMineId("");
                setBetId("");
                setCashValue("");
                setHitCount(0);
                setIsBet(false);
                setPoints([]);
                setUpdateRes(res)
                localStorage.removeItem("betId");
                localStorage.removeItem("mineId");
                setLoading(false);
                setTimeout(() => {
                    freshBoard();
                }, 3000);
            }
            else if (res?.status === false && res?.message === "Mine result already updated") {
                setMineId("");
                setBetId("");
                setCashValue("");
                setHitCount(0);
                setIsBet(false);
                setPoints([]);
                localStorage.removeItem("betId");
                localStorage.removeItem("mineId");
                setLoading(false);
                setTimeout(() => {
                    freshBoard();
                }, 3000);
            }
            else {
                setLoading(false);
            }
        }, 500);
    }


    //  === >>> Auto Pick Function


    const autopick = () => {
        let x = random(0, row - 1).toString();
        let y = random(0, column - 1).toString();
        let point = x + y;
        if (points.includes(point)) {
            autopick();
        }
        else {
            points.push(point)
            revealcell(x, y);
        }
    }

    function random(min = 0, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }


    //  >>> Common Functions 

    //  Error Function

    const errorFunction = () => {
        if (userToken === null || userToken === undefined || userToken === "") {
            setModal(!modal);
        }
        else {
            Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
    }


    const getBetAmount = (inputObj) => {
        const { value } = inputObj;
        if (value <= maxBet) {
            setBetAmount(value);
            return true;
        }
    }

    const getMaxBetAmount = (inputObj) => {
        const { value } = inputObj;
        if (value <= maxBet) {
            setMaxBetAmount(value);
            return true;
        }
    }

    const maximumBetAmount = () => {
        Confirm.show(`${t('Confirmation')}`, `${t('Maximum bet applied, please confirm')}`,
            `${t('Yes')}`,
            `${t('No')}`,
            () => {
                setBetAmount(maxBet);
            },
            () => {

            },
            {
            },
        );
    }

    //  >>> >>> Multiplier Functions

    const setShareAmount = (type) => {
        if (type === "/2") {
            let calc = +betRef.current / 2;
            if (calc > minBet) {
                setBetAmount(calc);
            }
            else {
                setBetAmount(minBet);
            }
        }
        else if (type === "2x") {
            let calc = +betRef.current * 2;
            if (calc < maxBet) {
                setBetAmount(calc);
            }
            else {
                setBetAmount(maxBet);
            }
        }
    }

    useEffect(() => {
        freshBoard()
    }, [mineCount]);



    //  ========= ======= ==== Auto Mode Bet Functions ==== ==== === 


    //  >>> >>>  On Win && On Loss Functions

    const onWinPercentage = (inputObj) => {
        const { value } = inputObj;
        if (value <= 100 && betAmount !== "") {
            setOnWinAmount(value);
            setWinPercentage(+betAmount / 100 * +value);
            return true;
        }
        else if (betAmount === "") {
            Notify.failure(`${t('Bet Amount is Empty')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
        }
        else {
            Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
        }
    }

    const onLossPercentage = (inputObj) => {
        const { value } = inputObj;
        if (value <= 100 && betAmount !== "") {
            setOnLossAmount(value);
            setLossPercentage(+betAmount / 100 * +value);
            return true;
        }
        else if (betAmount === "") {
            Notify.failure(`${t('Bet Amount is Empty')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
        }
        else {
            Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
        }
    }




    //  ==== >>> >> Start Function 

    const startFunction = async () => {
        if (selectedPoints?.length === 0 || balanceRef.current <= 0) {
            Notify.failure(balanceRef.current <= 0 ? `${t('Not Enough Balance')} !!!` : `${t('Please Select the Mine Box')}  !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (balanceRef.current <= +betRef.current || balanceRef?.current === 0) {
            Notify.failure(balanceRef?.current === 0 ? `${t('Not Enough Balance')} !!!` : `${t('Bet Amount Must be lesser then Balance')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (minBet > betRef.current) {
            Notify.failure(`${t('Bet Amount Must be higher then Minimum Amount')} !! `, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else if (maxBet < betRef.current) {
            Notify.failure(`${t('Bet Amount Must be lesser then Maximum Amount')} !!`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" })
        }
        else {
            setIsBet(true);
            setwifiLoad(true);
            setUpdateStatus(true);
            if (no_of_Bets) {
                boardReveal2();
            }
            else {
                boardReveal1();
            }
        }
    }



    //  Reveal Function Infinity Loop

    const boardReveal1 = async () => {
        reveal = setInterval(async () => {
            if (balanceRef.current <= 0) stopFunction();
            else if (statusRef.current === true) {
                let data = {
                    "mine_level": mineCount,
                    "bet_amonut": betRef.current,
                    "currency": selectCurrency?.symbol,
                    "type": mineMode,
                    "hitId": selectedPoints?.length
                }
                await dispatch(betMines(data)).then(async (res) => {
                    console.log("🚀 ~ file: index.js:940 ~ awaitdispatch auto mode mine bet ~ res:", res)
                    if (res?.status === true) {
                        setUpdateRes(res);
                        setUpdateStatus(false);
                        selectedPoints.map(async (temp, index) => {
                            let point = await temp?.toString();
                            let x = point.charAt(0);
                            let y = point.charAt(1);
                            values[index] = await autoRevealcell(x, y);
                        });
                        await isWon.push(values);
                        setTimeout(async () => {
                            await isWonFunction(res);
                        }, 300);
                    }
                }).catch((err) => {
                    setwifiLoad(false);
                });
            }
        }, 2000);
    }

    //  Number of Bets Reveal Function

    const boardReveal2 = async () => {
        reveal = setInterval(async () => {
            if (+no_of_Bets <= 0) stopFunction();
            else if (statusRef.current === true) {
                let data = {
                    "mine_level": mineCount,
                    "bet_amonut": betRef.current,
                    "currency": selectCurrency?.symbol,
                    "type": mineMode,
                    "hitId": selectedPoints?.length
                }
                await dispatch(betMines(data)).then(async (res) => {
                    console.log("🚀 ~ file: index.js:975 ~ awaitdispatch  auto Bet ~ res:", res)
                    if (res?.status === true) {
                        setUpdateRes(res);
                        setUpdateStatus(false);
                        selectedPoints.map(async (temp, index) => {
                            let point = await temp?.toString();
                            let x = point.charAt(0);
                            let y = point.charAt(1);
                            values[index] = await autoRevealcell(x, y);
                        });
                        await isWon.push(values);

                        setTimeout(async () => {
                            set_No_of_Bets((prev) => +prev - 1);
                            await isWonFunction(res);
                        }, 300);
                    }
                }).catch((err) => {
                    setwifiLoad(false);
                });
            }
        }, 2000);
    }





    //  === === >>> >>> >>> Auto Mode Board Reveal Functions 


    const autoRevealcell = async (x, y) => {
        let newGrid = gridRef?.current;
        return new Promise(async (resolve, reject) => {
            if (newGrid[x][y].value === "X" && nonMinecount !== 0) {
                // for (let i = 0; i < mineLocation?.length; i++) {
                //     newGrid[mineLocation[i][0]][mineLocation[i][1]].revealed = true;
                // }
                // setGrid(newGrid);
                resolve(0);
            }
            if (nonMinecount === 0) {
                resolve(1);
            }
            else {
                let revealedboard = await revealed(newGrid, x, y, nonMinecount);
                setNonMinecount(revealedboard?.newNonMines);
                setGrid(revealedboard?.arr);
                resolve(1);
            }
        })
    }


    //  ==== >>> Won Function ==== >>> >>>

    const isWonFunction = async (betRes) => {
        return new Promise(async (resolve, reject) => {
            let param = {};
            if (valuesRef.current?.includes(0)) {
                param = {
                    "betid": betRes?.betId,
                    // "currency": selectCurrency?.symbol,
                    "isMine": true,
                    "hitId": +selectedPoints?.length - 1,
                    "diamondCount": 0,
                    // "amount": +betRef?.current,
                }
                setLossAmount((prev) => +prev + +betRef.current)
            }
            else {
                param = {
                    "betid": betRes?.betId,
                    // "currency": selectCurrency?.symbol,
                    "isDiamond": true,
                    "hitId": +selectedPoints?.length - 1,
                    "diamondCount": +selectedPoints?.length - 1,
                    // "amount": +betRes?.multiplierValue * +betRef.current,
                }
                setCashValue((+betRes?.multiplierValue * +betRef.current).toFixed(8));
            }


            await dispatch(updateBetAuto(param)).then((res) => {
                console.log("🚀 ~ file: index.js:1057 ~ Update Mine Auto ~ res:", res);
                if (res?.status === true && res?.isWon === true) {
                    setBalance(res?.balance?.toFixed(8));
                    if (onWinIsChecked === true && onWinAmount !== "") {
                        let amt = +winPercentage + +betRef.current;
                        if (maxBet < amt || maxBetAmount !== "" && maxBetAmount < amt) {
                            setBetAmount(maxBetAmount ? maxBetAmount : maxBet);
                        }
                        else {
                            setBetAmount((prev) => +prev + +winPercentage);
                            if (betRef?.current !== "") {
                                setWinPercentage(+betRef?.current / 100 * +onWinAmount);
                            }
                            else {
                                Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
                            }
                        }
                    }
                    setUpdateRes(res)
                    setTimeout(() => {
                        freshBoard();
                        setTimeout(() => {
                            setUpdateStatus(true);
                        }, 1000)
                    }, 1000);

                }
                else if (res?.status === false && res?.isWon === false) {
                    setBalance(res?.balance?.toFixed(8));
                    if (onLossIsChecked === true && onLossAmount !== "") {
                        let amt = +lossPercentage + +betRef.current;
                        if (maxBet < amt || maxBetAmount !== "" && maxBetAmount < amt) {
                            setBetAmount(maxBetAmount ? maxBetAmount : maxBet);
                        }
                        else {
                            setBetAmount((prev) => +prev + +lossPercentage);
                            if (betRef?.current !== "") {
                                setLossPercentage(+betRef?.current / 100 * +onLossAmount);
                            }
                            else {
                                Notify.failure(`${t('Your bet is lower minimum available bet')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500, position: "center-top" });
                            }
                        }
                    }
                    setUpdateRes(res)
                    setTimeout(() => {
                        freshBoard();
                        setTimeout(() => {
                            setUpdateStatus(true);
                        }, 1000)
                    }, 1000);

                }
                resolve({
                    status: true,
                })
            })
        })
    }

    //  ==== === Stop Function >>>

    const stopFunction = () => {
        setwifiLoad(false);
        clearInterval(reveal);
        setIsBet(false);
        setLossAmount("");
        setCashValue("");
        setAutoIsStop(false);
        setUpdateStatus(false);
    }

    // Stop Functions  Dependencies


    //  Stop On Profit Dependencies

    useEffect(() => {
        if (cashValue !== undefined && cashValue !== "" && cashValue !== null && stopOnProfit !== undefined && stopOnProfit !== "" && stopOnProfit !== null) {
            if (+cashValue <= 0 || +stopOnProfit <= 0 || +cashValue >= +stopOnProfit) {
                stopFunction();
            }
        }
    }, [cashValue && cashValue]);


    //  Stop On Loss Dependencies

    useEffect(() => {
        if (lossAmount !== undefined && lossAmount !== "" && lossAmount !== null && stopOnLoss !== undefined && stopOnLoss !== null && stopOnLoss !== "")
            if (+lossAmount <= 0 || +stopOnLoss <= 0 || +lossAmount >= +stopOnLoss) {
                stopFunction();
            }
    }, [lossAmount && lossAmount]);

    //  Stop Number of Bets

    useEffect(() => {
        if (no_of_Bets !== undefined && no_of_Bets !== null && no_of_Bets !== "") {
            if (+no_of_Bets <= 0) {
                stopFunction();
            }
        }
    }, [no_of_Bets]);


    // Stop Infinity Bets 

    useEffect(() => {
        if (+balanceRef.current <= 0 || +betRef.current >= +balanceRef.current) {
            stopFunction();
        }
    }, [balance]);

    //   Get Single Bet  History 

    const getSingleBetDetails = async (betId, gameName) => {
        let postData = {
            "game": gameName?.toLowerCase(),
            "gameId": betId
        }
        let gameRes = await dispatch(getSingleBetView(postData));
        if (gameRes?.status) {
            setBetDetails(gameRes?.data);
            toggleBetDetails();
        }
        else {
            setBetDetails([]);
        }
    }

    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">

                            <div className="minespage-maincnt">

                                <section class="minepage-topcnt">
                                    <div class="">
                                        <div class="minegame-maincnt">
                                            <div class="mine-inrgrid">
                                                <div class="mineside-box">
                                                    <img src={diamond} alt="" class="img-fluid dimndVw" />
                                                    <p>{nonMinecount}</p>
                                                </div>
                                                <div class="minegame-mainbox minegame-danger">
                                                    <div class="minegame-grid">

                                                        {grid.map((singlerow, index1) => {
                                                            return (
                                                                <div key={index1}>
                                                                    {singlerow.map((singlecol, index2) => {
                                                                        return <Cell details={singlecol} key={index2} autoIsStop={autoIsStop} isBet={isBet} updateFlag={updateFlag} revealcell={revealcell} />
                                                                    })}

                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                                <div class="mineside-box">
                                                    <img src={boomb} alt="" class="img-fluid dimndVw1" />
                                                    <p>{mineCount}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mineslider-bg">
                                            <div class="mineslider-grid">
                                                <div class="mine-slider">
                                                    <Slider ref={c => (setSlider(c))} {...settings}>
                                                        {
                                                            multiplier?.length > 0 ? multiplier && multiplier?.map((temp, index) =>
                                                                <div class="slider-item" key={index}>
                                                                    <div class="minecnt-slidermain">
                                                                        <div class={temp?.hits === hitCount ? "mineslider-cnt betCount" : "mineslider-cnt"}>
                                                                            <h5>{temp?.multiplerValue}</h5>
                                                                            <p>{temp?.hits} {t('Hit')}</p>
                                                                        </div>
                                                                        <div><img src={arrrgt} alt="" class="img-fluid" /></div>
                                                                    </div>
                                                                </div>
                                                            )
                                                                :
                                                                <div class="slider-item">
                                                                    <div class="minecnt-slidermain">
                                                                        {t("Loading")}...
                                                                    </div>
                                                                </div>
                                                        }
                                                    </Slider>
                                                </div>
                                                <div className="mineslider-prevnext"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="minegame-rightcnt">
                                        <div class="minegame-top">
                                            <div class="minegame-topbox">
                                                {/* <button onClick={() => setIsVolume(!isVolume)}>
                                                    <img src={volhigh} alt="" class="img-fluid" />
                                                </button> */}
                                                {/* {
                                                isVolume ?
                                                    <input type="range" min="1" max="100"  />
                                                    :
                                                    null
                                            } */}
                                            </div>
                                            {/* <div class="minegame-topbox">
                                            <button>
                                                <img src={infocrl} alt="" class="img-fluid" />
                                            </button>
                                        </div>
                                        <div class="minegame-topbox">
                                            <button>
                                                <img src={health} alt="" class="img-fluid" />
                                            </button>
                                        </div> */}
                                        </div>
                                        <div class="minegame-rightmain d-none d-md-block">

                                            {/* <div class="minegame-value">
                                                <div class="valuegrid-box">
                                                    <div>
                                                        <img src={valicon} alt="" class="img-fluid" />
                                                        <span class="cur_Name">{selectCurrency?.name}</span>
                                                    </div>
                                                    <span class="cur_Name">{balance}</span>
                                                    <div class="value-2">
                                                        <button disabled={isBet} onClick={() => setShareAmount("/2")}> 1/2 </button>
                                                        <button disabled={isBet} onClick={() => setShareAmount("2x")}> 2x </button>
                                                    </div>
                                                </div>
                                                <div className="price-input">
                                                    <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={betAmount} placeholder="100.000" isAllowed={getBetAmount} />
                                                </div>
                                            </div> */}

                                            <div class="mines_sec_1 py-0 MinsBetMnu">
                                                <div className="hji_tr d-flex align-items-center justify-content-between" style={{ cursor: isBet ? "not-allowed" : "pointer" }} >
                                                    <div class="MinMaxCnt">
                                                        <button className="btn mb-1" disabled={isBet} onClick={() => setBetAmount(Number(minBet)?.toFixed(2))}>{t("Minimum")}</button>
                                                        <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={maximumBetAmount}>{t("Maximum")}</button>
                                                    </div>
                                                    <div className="d-flex align-items-center pg_ki">
                                                        <div class="CurncyIcon mr-2">
                                                            {/* <img src={dim} alt="" /> */}
                                                            <b>R$</b>
                                                        </div>
                                                        <div className="form-group mb-0">
                                                            <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={betAmount} placeholder="100.000" isAllowed={getBetAmount} />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn mb-1" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("/2")}>1/2</button>
                                                        <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("2x")}>2X</button>
                                                    </div>

                                                </div>
                                            </div>


                                            <div className="minmax-minsbox">

                                                {/* <div class="minmax-totbox">
                                                    <button class="minmax-box mr-2" disabled={isBet} style={{ cursor: "pointer" }} onClick={() => setBetAmount(minBet)}>{t('MIN')}</button>
                                                    <button class="minmax-box" disabled={isBet} style={{ cursor: "pointer" }} onClick={maximumBetAmount}>{t('MAX')}</button>
                                                </div> */}

                                                <div class="mine-no">
                                                    <div class="mineno-grid">
                                                        {
                                                            mineRes && mineRes?.map((temp, index) => {
                                                                if (index < 4)
                                                                    return <button class={temp?._id === betCountIsActive ? "betCount" : ""} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} key={index} onClick={() => getMultiplier(temp?._id)}>{temp?.mine_level}</button>
                                                            }
                                                            )
                                                        }

                                                        <div>
                                                            <select disabled={isBet} name="" id="" onChange={(e) => getMultiplier(e.target.value)}>
                                                                <option value="">{t("Mines")}</option>
                                                                {
                                                                    mineRes && mineRes.map((temp, index) =>
                                                                        <option key={index} value={temp?._id}>{temp?.mine_level}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="betautopick-box">

                                                <div class="cashout-box gmBtBtn v2">
                                                    {
                                                        isBet && activeTab === "1" ?
                                                            <button style={{ cursor: cashValue ? "pointer" : "not-allowed" }} disabled={cashValue !== "" ? false : true} onClick={() => cashOutFun(true, "isDiamond")}>{cashValue && isBet ? t("CASHOUT") : <>{t("Bet")}<br />{t("Next Round")}</>}
                                                                <br />
                                                                <span>{cashValue ? cashValue : null}</span>
                                                            </button>
                                                            :
                                                            activeTab === "2" ?
                                                                <div className='d-flex align-items-center'>
                                                                    <div className={wifiLoad ? 'pulse mr-2' : ""}>
                                                                        {
                                                                            isBet ?
                                                                                <button style={{ cursor: "pointer" }} onClick={stopFunction}>
                                                                                    {t("Stop")}
                                                                                    <br />
                                                                                    <span>{no_of_Bets > 0 ? no_of_Bets : "∞"}</span>
                                                                                </button>
                                                                                :
                                                                                <button style={{ cursor: "pointer" }} onClick={betAmount && userToken ? startFunction : errorFunction}>
                                                                                    {t("START")}
                                                                                    <br />
                                                                                    <span>{no_of_Bets > 0 ? no_of_Bets : "∞"}</span>
                                                                                </button>
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        <Radio
                                                                            visible={wifiLoad}
                                                                            height="30"
                                                                            width="30"
                                                                            colors={['#fff', '#fff', '#fff']}
                                                                            ariaLabel="radio-loading"
                                                                            wrapperStyle={{}}
                                                                            wrapperClass="radio-wrapper"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <button style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={betAmount && userToken ? betFunction : errorFunction}>{t("Bet")}</button>
                                                    }
                                                </div>
                                                <div class="pick-btn mt-3">
                                                    <button class="active" disabled={mineMode === "manual" && isBet ? false : true} onClick={autopick}>{t("Autopick")}</button>
                                                    <button>{t("Pick a Slot")}</button>
                                                    <div class="or-txt">{t("OR")}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="minegame-rightmain MblMinMnu d-md-none d-block">
                                            <div class="MnBetBtnsGrd">
                                                <div class="mines_sec_1 py-0 MinsBetMnu mr-3">
                                                    <div className="hji_tr d-flex align-items-center justify-content-between" style={{ cursor: isBet ? "not-allowed" : "pointer" }} >
                                                        <div class="MinMaxCnt">
                                                            <button className="btn mb-1" disabled={isBet} onClick={() => setBetAmount(Number(minBet)?.toFixed(2))}>{t("Minimum")}</button>
                                                            <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={maximumBetAmount}>{t("Maximum")}</button>
                                                        </div>
                                                        <div className="d-flex align-items-center pg_ki">
                                                            <div class="CurncyIcon mr-2">
                                                                {/* <img src={dim} alt="" /> */}
                                                                <b>R$</b>
                                                            </div>
                                                            <div className="form-group mb-0">
                                                                <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={betAmount} placeholder="100.000" isAllowed={getBetAmount} />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button className="btn mb-1" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("/2")}>1/2</button>
                                                            <button className="btn" style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={() => setShareAmount("2x")}>2X</button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="cashout-box gmBtBtn v2 mt-0">
                                                    {
                                                        isBet && activeTab === "1" ?
                                                            <button style={{ cursor: cashValue ? "pointer" : "not-allowed" }} disabled={cashValue !== "" ? false : true} onClick={() => cashOutFun(true, "isDiamond")}>{cashValue && isBet ? t("CASHOUT") : <>{t("Bet")}<br />{t("Next Round")}</>}
                                                                <br />
                                                                <span>{cashValue ? cashValue : null}</span>
                                                            </button>
                                                            :
                                                            activeTab === "2" ?
                                                                <div className='d-flex align-items-center'>
                                                                    <div className={wifiLoad ? 'pulse mr-2' : ""}>
                                                                        {
                                                                            isBet ?
                                                                                <button style={{ cursor: "pointer" }} onClick={stopFunction}>
                                                                                    {t("Stop")}
                                                                                    <br />
                                                                                    <span>{no_of_Bets > 0 ? no_of_Bets : "∞"}</span>
                                                                                </button>
                                                                                :
                                                                                <button style={{ cursor: "pointer" }} onClick={betAmount && userToken ? startFunction : errorFunction}>
                                                                                    {t("START")}
                                                                                    <br />
                                                                                    <span>{no_of_Bets > 0 ? no_of_Bets : "∞"}</span>
                                                                                </button>
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        <Radio
                                                                            visible={wifiLoad}
                                                                            height="30"
                                                                            width="30"
                                                                            colors={['#fff', '#fff', '#fff']}
                                                                            ariaLabel="radio-loading"
                                                                            wrapperStyle={{}}
                                                                            wrapperClass="radio-wrapper"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <button style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} onClick={betAmount && userToken ? betFunction : errorFunction}>{t("Bet")}</button>
                                                    }
                                                </div>
                                            </div>

                                            <div className="betautopick-box">
                                                <div className="minmax-minsbox">

                                                    {/* <div class="minmax-totbox">
                                                        <button class="minmax-box mr-2" disabled={isBet} style={{ cursor: "pointer" }} onClick={() => setBetAmount(minBet)}>{t('MIN')}</button>
                                                        <button class="minmax-box" disabled={isBet} style={{ cursor: "pointer" }} onClick={maximumBetAmount}>{t('MAX')}</button>
                                                    </div> */}

                                                    <div class="mine-no w-100">
                                                        <div class="mineno-grid">
                                                            {
                                                                mineRes && mineRes?.map((temp, index) => {
                                                                    if (index < 4)
                                                                        return <button class={temp?._id === betCountIsActive ? "betCount" : ""} style={{ cursor: isBet ? "not-allowed" : "pointer" }} disabled={isBet} key={index} onClick={() => getMultiplier(temp?._id)}>{temp?.mine_level}</button>
                                                                }
                                                                )
                                                            }

                                                            <div class="w-100">
                                                                <select disabled={isBet} name="" id="" onChange={(e) => getMultiplier(e.target.value)}>
                                                                    <option value="">{t("Mines")}</option>
                                                                    {
                                                                        mineRes && mineRes.map((temp, index) =>
                                                                            <option key={index} value={temp?._id}>{temp?.mine_level}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="pick-btn mt-3">
                                                    <button class="active" disabled={mineMode === "manual" && isBet ? false : true} onClick={autopick}>{t("Autopick")}</button>
                                                    <button>{t("Pick a Slot")}</button>
                                                    <div class="or-txt">{t("OR")}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section className="mines_sec_2">
                                    <div className="m-0">
                                        <div className=" d-flex justify-content-center">
                                            <Nav tabs className="ma_ato_tab">
                                                <NavItem>
                                                    <NavLink
                                                        disabled={isBet}
                                                        className={classnames({ active: activeTab === '1' })}
                                                        onClick={() => { changeMode('manual') }}
                                                    >
                                                        {t("Manual")}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        disabled={isBet}
                                                        className={classnames({ active: activeTab === '2' })}
                                                        onClick={() => { changeMode('auto') }}
                                                    >
                                                        {t("Auto")}
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </div>
                                        <div className="pt-2">
                                            <TabContent activeTab={activeTab}>
                                                <TabPane tabId="1">
                                                    <div className="ahm_sec m-0">
                                                        <div className=" d-md-flex align-items-center justify-content-between flex-wrap">
                                                            <Nav tabs className="ahm_tab_hd my-2">
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '1' })}
                                                                        onClick={() => { toggleInner('1'); }}
                                                                    >
                                                                        {t("All Bets")}
                                                                    </NavLink>
                                                                </NavItem>
                                                                {
                                                                    userToken ?
                                                                        <NavItem>
                                                                            <NavLink
                                                                                className={classnames({ active: activeTab1 === '2' })}
                                                                                onClick={() => { toggleInner('2'); }}
                                                                            >
                                                                                {t("My Bets")}
                                                                            </NavLink>
                                                                        </NavItem>
                                                                        :
                                                                        null
                                                                }
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '3' })}
                                                                        onClick={() => { toggleInner('3'); }}
                                                                    >
                                                                        {t("High Rollers")}
                                                                    </NavLink>
                                                                </NavItem>

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '4' })}
                                                                        onClick={() => { toggleInner('4'); }}
                                                                    >
                                                                        {t("Rare Wins")}
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                            {/* <div className="ahm-sel-bx d-flex align-items-center my-md-2 mt-3">
                                                                <h2 className="mr-2 mb-0"> {t("Show")}</h2>
                                                                <div className="form-group mb-0">
                                                                    <select className="form-control"
                                                                        id="exampleFormControlSelect1" onChange={(event) => gameBetHistory(event.target.value)} >
                                                                        {
                                                                            betCounts?.map((temp, index) =>
                                                                                <option key={index} value={temp?.value}>{temp?.pageLimit}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                        </div>

                                                        {/* History Starts Here Manual Mode */}

                                                        <div className="pt-2">
                                                            <TabContent activeTab={activeTab1}>
                                                                <TabPane tabId="1">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                {
                                                                                    gamehist?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {gamehist?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>

                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }}
                                                                                                                        src={elements?.user_id?.profile_picture} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}>{elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>
                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                gamehist?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="2">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    onegamehistory?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {onegamehistory?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>

                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                onegamehistory?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="3">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    mineHighRollers?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {mineHighRollers?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                mineHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="4">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    winnerLists?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {winnerLists?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                winnerLists?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                            </TabContent>
                                                        </div>
                                                    </div>
                                                </TabPane>

                                                <TabPane tabId="2">
                                                    <div class="auto-mem_1">
                                                        <div class="row">
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Number Of Bets")} </h2>
                                                                <div class="input-group mb-3">
                                                                    <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={no_of_Bets <= 0 ? "" : no_of_Bets} onChange={(e) => set_No_of_Bets(e.target.value)} />
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text"><svg width="18"
                                                                            height="8" viewBox="0 0 18 8" fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="M8.99974 4.00008C8.54246 4.88773 7.92939 5.68598 7.18974 6.35675C6.7236 6.82303 6.12966 7.14059 5.48303 7.26929C4.8364 7.39799 4.16612 7.33204 3.55698 7.07978C2.94783 6.82752 2.42718 6.40027 2.06086 5.85209C1.69455 5.3039 1.49902 4.6594 1.49902 4.00008C1.49902 3.34077 1.69455 2.69626 2.06086 2.14808C2.42718 1.59989 2.94783 1.17265 3.55698 0.920388C4.16612 0.668126 4.8364 0.602173 5.48303 0.730872C6.12966 0.859571 6.7236 1.17714 7.18974 1.64342C7.92939 2.31419 8.54246 3.11243 8.99974 4.00008ZM8.99974 4.00008C9.45701 3.11243 10.0701 2.31419 10.8097 1.64342C11.2759 1.17714 11.8698 0.859571 12.5164 0.730872C13.1631 0.602173 13.8333 0.668126 14.4425 0.920388C15.0516 1.17265 15.5723 1.59989 15.9386 2.14808C16.3049 2.69626 16.5004 3.34077 16.5004 4.00008C16.5004 4.6594 16.3049 5.3039 15.9386 5.85209C15.5723 6.40027 15.0516 6.82752 14.4425 7.07978C13.8333 7.33204 13.1631 7.39799 12.5164 7.26929C11.8698 7.14059 11.2759 6.82303 10.8097 6.35675C10.0701 5.68598 9.45701 4.88773 8.99974 4.00008Z"
                                                                                stroke="#48567B" stroke-width="1.25"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round" />
                                                                        </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Stop on profit")}</h2>
                                                                <div class="form-group ">
                                                                    <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={stopOnProfit} onChange={(e) => setStopOnProfit(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Stop on loss")}</h2>
                                                                <div class="form-group ">
                                                                    <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={stopOnLoss} onChange={(e) => setStopOnLoss(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t("Max bet amount")}</h2>
                                                                <div class="input-group mb-3">
                                                                    <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={maxBetAmount} isAllowed={getMaxBetAmount} />
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text"
                                                                            id="basic-addon2"><svg width="18" height="8"
                                                                                viewBox="0 0 18 8" fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg">
                                                                                <path
                                                                                    d="M8.99974 4.00008C8.54246 4.88773 7.92939 5.68598 7.18974 6.35675C6.7236 6.82303 6.12966 7.14059 5.48303 7.26929C4.8364 7.39799 4.16612 7.33204 3.55698 7.07978C2.94783 6.82752 2.42718 6.40027 2.06086 5.85209C1.69455 5.3039 1.49902 4.6594 1.49902 4.00008C1.49902 3.34077 1.69455 2.69626 2.06086 2.14808C2.42718 1.59989 2.94783 1.17265 3.55698 0.920388C4.16612 0.668126 4.8364 0.602173 5.48303 0.730872C6.12966 0.859571 6.7236 1.17714 7.18974 1.64342C7.92939 2.31419 8.54246 3.11243 8.99974 4.00008ZM8.99974 4.00008C9.45701 3.11243 10.0701 2.31419 10.8097 1.64342C11.2759 1.17714 11.8698 0.859571 12.5164 0.730872C13.1631 0.602173 13.8333 0.668126 14.4425 0.920388C15.0516 1.17265 15.5723 1.59989 15.9386 2.14808C16.3049 2.69626 16.5004 3.34077 16.5004 4.00008C16.5004 4.6594 16.3049 5.3039 15.9386 5.85209C15.5723 6.40027 15.0516 6.82752 14.4425 7.07978C13.8333 7.33204 13.1631 7.39799 12.5164 7.26929C11.8698 7.14059 11.2759 6.82303 10.8097 6.35675C10.0701 5.68598 9.45701 4.88773 8.99974 4.00008Z"
                                                                                    stroke="#48567B" stroke-width="1.25"
                                                                                    stroke-linecap="round"
                                                                                    stroke-linejoin="round" />
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t('On win')}</h2>
                                                                <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
                                                                    <div class="mr-3">
                                                                        <div class="swi_nd mb-3">
                                                                            <div class="d-flex align-items-center">
                                                                                <label class="switch mb-0">
                                                                                    <input type="checkbox" checked={onWinIsChecked} onChange={() => setOnWinIsChecked(!onWinIsChecked)} />
                                                                                    <span class="slider"></span>
                                                                                </label>
                                                                                <div>
                                                                                    <h2 class="mb-0 active">{t("Reset")} </h2>
                                                                                    <h2 class="mb-0">{t("Increase")}</h2>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div class="input-group mb-3">
                                                                            <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={onWinAmount} onFocus={() => setOnWinIsChecked(true)} isAllowed={onWinPercentage} />
                                                                            <div class="input-group-append">
                                                                                <span class="input-group-text" id="basic-addon2">%
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="col-lg-4 col-md-6 col-6">
                                                                <h2>{t('On loss')}</h2>
                                                                <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
                                                                    <div class="mr-3">
                                                                        <div class="swi_nd mb-3">
                                                                            <div class="d-flex align-items-center ">
                                                                                <label class="switch mb-0">
                                                                                    <input type="checkbox" checked={onLossIsChecked} onChange={() => setOnLossIsChecked(!onLossIsChecked)} />
                                                                                    <span class="slider"></span>
                                                                                </label>
                                                                                <div>
                                                                                    <h2 class="mb-0 ">{t("Reset")} </h2>
                                                                                    <h2 class="mb-0 active">{t("Increase")}</h2>
                                                                                </div >
                                                                            </div >
                                                                        </div >
                                                                    </div >
                                                                    <div>
                                                                        <div class="input-group mb-3">
                                                                            <NumericFormat style={{ cursor: isBet ? "not-allowed" : "pointer" }} class="form-control" value={onLossAmount} onFocus={() => setOnLossIsChecked(true)} isAllowed={onLossPercentage} />
                                                                            <div class="input-group-append">
                                                                                <span class="input-group-text" id="basic-addon2">%
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div >
                                                            </div >
                                                        </div >
                                                    </div >

                                                    {/* Game History Here */}

                                                    <div className="ahm_sec m-0">
                                                        <div className=" d-md-flex align-items-center justify-content-between flex-wrap">
                                                            <Nav tabs className="ahm_tab_hd my-2">
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '1' })}
                                                                        onClick={() => { toggleInner('1'); }}
                                                                    >
                                                                        {t("All Bets")}
                                                                    </NavLink>
                                                                </NavItem>

                                                                {
                                                                    userToken ?
                                                                        <NavItem>
                                                                            <NavLink
                                                                                className={classnames({ active: activeTab1 === '2' })}
                                                                                onClick={() => { toggleInner('2'); }}
                                                                            >
                                                                                {t("My Bets")}
                                                                            </NavLink>
                                                                        </NavItem>
                                                                        :
                                                                        null
                                                                }

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '3' })}
                                                                        onClick={() => { toggleInner('3'); }}
                                                                    >
                                                                        {t("High Rollers")}
                                                                    </NavLink>
                                                                </NavItem>

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab1 === '4' })}
                                                                        onClick={() => { toggleInner('4'); }}
                                                                    >
                                                                        {t("Rare Wins")}
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                            {/* <div className="ahm-sel-bx d-flex align-items-center my-md-2 mt-3">
                                                                <h2 className="mr-2 mb-0"> {t("Show")}</h2>
                                                                <div className="form-group mb-0">
                                                                    <select className="form-control"
                                                                        id="exampleFormControlSelect1" onChange={(event) => gameBetHistory(event.target.value)} >
                                                                        {
                                                                            betCounts?.map((temp, index) =>
                                                                                <option key={index} value={temp?.value}>{temp?.pageLimit}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="pt-2">
                                                            <TabContent activeTab={activeTab1}>
                                                                <TabPane tabId="1">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                {
                                                                                    gamehist?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {gamehist?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">

                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }}
                                                                                                                        src={elements?.user_id?.profile_picture} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>
                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}>{elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>
                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                gamehist?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="2">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    onegamehistory?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {onegamehistory?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                onegamehistory?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="3">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    mineHighRollers?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {mineHighRollers?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>

                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id?.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                mineHighRollers?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                                <TabPane tabId="4">
                                                                    <div className="ahm_sec_table_tl">
                                                                        <div className="table-responsive">
                                                                            <table className="table table-borderless mb-0">
                                                                                <thead className="table_head">
                                                                                    <tr>
                                                                                        <th>{t("Players")}</th>
                                                                                        <th>{t("Bet Amount")}</th>
                                                                                        <th>{t("Multiplier")}</th>
                                                                                        <th>{t("Payout")}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                {
                                                                                    winnerLists?.length > 0 ?
                                                                                        <tbody className="table_body">
                                                                                            {winnerLists?.map((elements, index) => {
                                                                                                return (
                                                                                                    <SkeletonTheme baseColor="#444" height="25px" width="25px" highlightColor="#fff" borderRadius="80px">
                                                                                                        <tr style={{ cursor: 'pointer' }} key={index} onClick={() => getSingleBetDetails(elements?._id, elements?.game_name)}>
                                                                                                            <td class="ash_color">
                                                                                                                {elements?.user_id?.profile_picture ? (
                                                                                                                    <img class="ash_color" src={elements?.user_id?.profile_picture} style={{ height: "25px", width: "25px", borderRadius: "20px", margin: "5px" }} />
                                                                                                                ) : (<Skeleton />)}
                                                                                                                {elements?.user_id.username}</td>

                                                                                                            <td>{elements?.betAmonut}</td>
                                                                                                            <td><button class={elements?.isMine ? "btn red_btn" : "btn grn_btn"}> {elements?.multipliers}</button></td>
                                                                                                            <td>{elements?.payout?.toFixed(8)}</td>

                                                                                                        </tr>
                                                                                                    </SkeletonTheme>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </table>
                                                                            {
                                                                                winnerLists?.length <= 0 ?
                                                                                    <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </TabPane>
                                                            </TabContent>
                                                        </div>
                                                    </div>
                                                </TabPane >
                                            </TabContent >
                                        </div >
                                    </div >
                                </section >
                            </div >
                        </div>
                        <Footer />
                    </div >
                </div >
            </div >


            {/*  Bet Details  Modal */}

            <Modal
                isOpen={betModal}
                toggle={toggleBetDetails}
                className="minesmodal-popup"
                autoFocus={false}
                centered
            >
                <ModalBody className="p-0">
                    <div class="minesmodal-content">
                        <div class="row">
                            <div className="text-right">
                                <Link to="#" onClick={toggleBetDetails}>
                                    <img src={circle} alt="" />
                                </Link>
                            </div>
                            <div class="col-lg-12 mt-2">
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        <div class="mines-detbox"><img src={betDetails?.gameId?.gameIcon} alt="Image Not Found" class="img-fluid" /></div>
                                    </div>
                                    <div class="col-md-6 mt-3 mt-md-0">
                                        <div class="mines-detbox d-flex flex-column justify-content-center">
                                            <h5>{t('Player')}: <span>{betDetails?.user_id?.username}</span></h5>
                                            <h5 class="my-2">{t('Date & Time')}: <span>{betDetails?.created_at}</span></h5>
                                            <h5>{t('Bet ID')}: <span className="brk_Wrd">{betDetails?.gameCode}</span></h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-7 col-md-4 mx-auto" q >
                                        <div class="mines-detmain">
                                            <p>{t('Bet')}</p>
                                            <h5>{betDetails?.betAmonut}</h5>
                                        </div>
                                    </div>
                                    <div class="col-sm-7 col-md-4 my-3 my-md-0 mx-auto">
                                        <div class="mines-detmain">
                                            <p>{t('Multiplier')}</p>
                                            <h5>{betDetails?.multipliers}</h5>
                                        </div>
                                    </div>
                                    <div class="col-sm-7 col-md-4 mx-auto">
                                        <div class="mines-detmain">
                                            <p>{t('Payout')}</p>
                                            <h5>{betDetails?.payout}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </Fragment >
    );

}

export default Mines;